<template>
  <div style="background: #f2f2f6; height: 100%">
        <el-table
          :data="devicelist"
          ref="table"
          stripe
          height="99%"
          style="width: 100%; border-radius: 0 0 10px 10px;"
          :header-cell-style="{ 'text-align': 'center' }"
          :cell-style="{ height: '50px', padding: '0', 'text-align': 'center' }">
           <el-table-column
            width="50">
               <template slot-scope="scope">
               <img style="width:25px;height:25px;margin:12.5px auto 0;" :src="'./static/images/icon/'+scope.row.type+'.png'"/>
                                </template>
          </el-table-column>
          <el-table-column
            prop="roomname"
            label="位置">
             <template slot-scope="scope">
                   <span> {{scope.row.floorname}}{{scope.row.roomname}}</span>
                </template>
          </el-table-column>
          <el-table-column
            prop="name"
            label="设备名称">
          </el-table-column>

          <el-table-column
            prop="errmsg"
            label="故障内容"
            >
              <template slot-scope="scope">
                <el-tag v-if="!!!scope.row.errorcode||scope.row.errorcode=='0'">正常</el-tag>
                <span v-else style="color:red">{{scope.row.errmsg}}</span>
              </template>
          </el-table-column>
          <el-table-column
            prop="errtime"
            label="故障发生时间"
          >
          <template slot-scope="scope">
                <span v-if="scope.row.errorcode&&scope.row.errorcode!='0'" style="color:red">{{scope.row.errtime}}</span>
              </template>
          </el-table-column>
            <el-table-column
            prop="createdtime"
            label="复位"
            size="small"
          >
           filter-placement="bottom-end">
      <template slot-scope="scope">
        <el-button v-if="scope.row.dpid"
          type="success"
         size="mini" @click="reset(scope.row)">复位</el-button>
         <span v-else>不支持</span>
        </template>
          </el-table-column>
        </el-table>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'ErrorPage',
  data () {
    return {
    }
  },
    computed: {
    devicelist () {
      return this.$store.state.devicelist.filter(d => { return d.type == 'heatpump'||d.type=='aricondition' })
    }
  },
  mounted: function () {
    var self = this
    let customer = window.localStorage.getItem('customer')
    if (customer) {
      
    } else {
      this.$message({
        message: this.$t("base.noSession"),
        type: 'warning'
      })
      self.$router.push({ name: 'Login' })
    }
  },
  methods: {
    reset (data) {
      let message = {
        devdpmsg: {
          devid: data.deviceid,
          dpid: data.dpid,
          data: 1
        }
      }
      this.Common.mqttSend(data.srcaddress, message)
    }
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Devices/RealtimeError.vue